import SoundManager from "../../../../../../../lib/html5-software-library/src/ranj/audio/SoundManager";
import RevisableLanguagePack from "../../../../../../../lib/html5-software-library/src/ranj/language/RevisableLanguagePack";
import MediatorManager from "../../../../../core/application/MediatorManager";
import EmailInteractionEvent from "../../../../email/controller/EmailInteractionEvent";
import EmailBoxType from "../../../../email/model/EmailBoxType";
import EmailInterfaceEvent from "../../../../email/model/EmailInterfaceEvent";
import LaptopSkinKeyRegistry from "../../../model/LaptopSkinKeyRegistry";
import LaptopSoundType from "../../../sound/LaptopSoundType";
import AbstractLaptopMediator from "../../AbstractLaptopMediator";

export default class LaptopEmailScreenMediator extends AbstractLaptopMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {RevisableLanguagePack} languagePack 
     * @param {MediatorManager} mediatorManager 
     * @param {SoundManager} soundManager 
     */
    constructor(target, dispatcher, languagePack, mediatorManager, soundManager) {
        super(target, dispatcher);

        this._languagePack = languagePack;
        this._mediatorManager = mediatorManager;
        this._soundManager = soundManager;
    }

    initialize() {
        super.initialize();

        this._target.applicationTitleTextField.text = this._languagePack.getText("laptop.emailScreen.title");

        this._closeButton = this.createButton(this._target.closeButton, this._handleCloseButton.bind(this), null, LaptopSoundType.CLICK);

        this._emailBoxSelectionMediator = this._mediatorManager.createMediator(this._target.boxButtons, LaptopSkinKeyRegistry.EMAIL_BOX_SELECTION_SKIN);

        this._target.conversationList.customData = {
            boxType: EmailBoxType.INBOX,
            skinKeyRegistry: LaptopSkinKeyRegistry,
            smallNpcImages: false
        };
        this._emailConversationListMediator = this._mediatorManager.createMediator(this._target.conversationList, LaptopSkinKeyRegistry.EMAIL_CONVERSATION_LIST_SKIN);

        this._target.conversation.customData = {
            skinKeyRegistry: LaptopSkinKeyRegistry
        };
        this._emailConversationMediator = this._mediatorManager.createMediator(this._target.conversation, LaptopSkinKeyRegistry.EMAIL_CONVERSATION_SKIN);
        this._target.conversation.visible = false;

        // prevent click through
        this._target.addEventListener('click', () => {});

        this.registerEventListener(EmailInteractionEvent.OPEN_MAILBOX, this._handleOpenMailboxRequest.bind(this));
        this.registerEventListener(EmailInteractionEvent.OPEN_CONVERSATION, this._handleOpenConversationRequest.bind(this));

        this.registerEventListener(EmailInteractionEvent.OPEN_DRAFT_CHOICE_PICKER, this._handleOpenDraftChoicePickerRequest.bind(this));
        this.registerEventListener(EmailInteractionEvent.CLOSE_DRAFT_CHOICE_PICKER, this._handleCloseDraftChoicePickerRequest.bind(this));
        this.registerEventListener(EmailInteractionEvent.SUBMIT_DRAFT, this._handleSubmitDraft.bind(this));

        this.registerEventListener(EmailInterfaceEvent.LOCK_INTERFACE, this._handleLockInterface.bind(this));
        this.registerEventListener(EmailInterfaceEvent.UNLOCK_INTERFACE, this._handleUnlockInterface.bind(this));
    }

    destroy() {
        super.destroy();

        this._emailBoxSelectionMediator.destroy();

        this._emailConversationListMediator.destroy();
        this._emailConversationMediator.destroy();
    }

    _handleCloseButton() {
        this.gotoScreen(LaptopSkinKeyRegistry.LAPTOP_MAIN_SCREEN_SKIN);
    }

    _handleOpenMailboxRequest(evt) {
        const boxType = evt.params.boxType;

        this._emailConversationListMediator.setBoxType(boxType);

        this._target.conversation.visible = false;
        this._target.conversationList.visible = true;
    }

    _handleOpenConversationRequest(evt) {
        const conversation = evt.params.conversation;

        this._emailConversationMediator.setConversation(conversation);

        this._target.conversation.visible = true;
        this._target.conversationList.visible = false;
    }

    _handleOpenDraftChoicePickerRequest(evt) {
        const mcBlock = evt.params.mcBlock;
        this._draftChoicePickerScreen = this.openScreen(LaptopSkinKeyRegistry.LAPTOP_EMAIL_DRAFT_OPTION_OVERLAY_SKIN, null, {
            mcBlock,
            skinKeyRegistry: LaptopSkinKeyRegistry
        });
    }

    _handleCloseDraftChoicePickerRequest(evt) {
        if (this._draftChoicePickerScreen) {
            this.closeScreen(this._draftChoicePickerScreen);
            this._draftChoicePickerScreen = null;
        }
    }

    _handleSubmitDraft(evt) {
        this.dispatch(EmailInteractionEvent.OPEN_MAILBOX, {boxType: EmailBoxType.INBOX});

        this._target.conversation.visible = false;
        this._target.conversationList.visible = true;
    }

    _handleLockInterface() {
        this._closeButton.setEnabled(false);
    }
    
    _handleUnlockInterface() {
        this._closeButton.setEnabled(true);
    }
}